// The icon set, bundled as markup instead of fetched.
//
// These used to be registered by URL, which made MatIconRegistry issue one HTTP request per
// icon — from the browser, and from the server during rendering, where the URL pointed at the
// public host and sent the request out through the CDN and back to the machine that was
// already holding the files. Both directions failed often enough to be among this app's
// loudest error reports, and neither can be made reliable from the client.
//
// The whole set is 8.6 KB (measured with `wc -c`, not `du`, which rounds 18 small files up to
// block size and overstates it roughly fivefold) against a main bundle measured in megabytes,
// so it is carried in the bundle and registered as literals: no request, nothing to retry, and
// the icons are present in server-rendered markup instead of appearing after hydration.
//
// Keys match the `SVG_ICONS` names; the registered icon name stays `calio-<key>-icon`.

import addGuest from '../../../../public/images/icons/add-guest.svg';
import arrowDown from '../../../../public/images/icons/arrow-down.svg';
import camera from '../../../../public/images/icons/camera.svg';
import checkMark from '../../../../public/images/icons/check-mark.svg';
import chevronRight from '../../../../public/images/icons/chevron-right.svg';
import email from '../../../../public/images/icons/email.svg';
import expandLess from '../../../../public/images/icons/expand-less.svg';
import grid from '../../../../public/images/icons/grid.svg';
import info from '../../../../public/images/icons/info.svg';
import list from '../../../../public/images/icons/list.svg';
import location from '../../../../public/images/icons/location.svg';
import locationFill from '../../../../public/images/icons/location-fill.svg';
import mobile from '../../../../public/images/icons/mobile.svg';
import moreAttendees from '../../../../public/images/icons/more-attendees.svg';
import pencil from '../../../../public/images/icons/pencil.svg';
import spinner from '../../../../public/images/icons/spinner.svg';
import times from '../../../../public/images/icons/times.svg';
import website from '../../../../public/images/icons/website.svg';

export const SVG_ICON_SET: Readonly<Record<string, string>> = {
  'add-guest': addGuest,
  'arrow-down': arrowDown,
  'camera': camera,
  'check-mark': checkMark,
  'chevron-right': chevronRight,
  'email': email,
  'expand-less': expandLess,
  'grid': grid,
  'info': info,
  'list': list,
  'location': location,
  'location-fill': locationFill,
  'mobile': mobile,
  'more-attendees': moreAttendees,
  'pencil': pencil,
  'spinner': spinner,
  'times': times,
  'website': website,
};
